import Dexie from 'dexie';

/**
 * Analytics Database
 * Caches BigQuery results locally for 24 hours to reduce cost and improve UX.
 */
export const analyticsDb = new Dexie('AnalyticsCacheDB');

analyticsDb.version(1).stores({
  cache: 'key, data, updatedAt' // key is stringified endpoint + params
});

/**
 * Get cached data if it's not expired
 * @param {string} key 
 * @param {number} ttl - Time to live in ms (default 24h)
 */
export const getCachedData = async (key, ttl = 24 * 60 * 60 * 1000) => {
  try {
    const record = await analyticsDb.cache.get(key);
    if (!record) return null;
    
    const isExpired = Date.now() - record.updatedAt > ttl;
    if (isExpired) {
      await analyticsDb.cache.delete(key);
      return null;
    }
    
    return record.data;
  } catch (error) {
    console.warn('Dexie read error:', error);
    return null;
  }
};

/**
 * Store data in cache
 * @param {string} key 
 * @param {any} data 
 */
export const setCachedData = async (key, data) => {
  try {
    await analyticsDb.cache.put({
      key,
      data,
      updatedAt: Date.now()
    });
  } catch (error) {
    console.warn('Dexie write error:', error);
  }
};

/**
 * Clear all analytics cache
 */
export const clearAnalyticsCache = async () => {
  try {
    await analyticsDb.cache.clear();
  } catch (error) {
    console.warn('Dexie clear error:', error);
  }
};

export default analyticsDb;
